import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=3910dafd&"
import script from "./tag.vue?vue&type=script&lang=js&"
export * from "./tag.vue?vue&type=script&lang=js&"
import style0 from "./tag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3910dafd')) {
      api.createRecord('3910dafd', component.options)
    } else {
      api.reload('3910dafd', component.options)
    }
    module.hot.accept("./tag.vue?vue&type=template&id=3910dafd&", function () {
      api.rerender('3910dafd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/tag/tag.vue"
export default component.exports